let fallDirection = 1;
let x1=0, y1=0;

const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
const dist_to_draw = 50;
const delay = 1000;
const fsize = ['2rem','2.4rem','1rem','1.7rem'];
const colors = ['#FFFFFF'];

const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
const selRand = (o) => o[rand(0, o.length-1)];
const distanceTo = (x1, y1, x2, y2) => Math.sqrt((Math.pow(x2-x1,2))+(Math.pow(y2-y1,2)));
const shouldDraw = (x, y) => (distanceTo(x1, y1, x, y) >= dist_to_draw);

/* ===============================
   BLIZZARD MODE GLOBALS
   =============================== */
let blizzardMode = false;
let blizzardInterval = null;

function enableBlizzardMode() {
  if (blizzardMode) return;
  blizzardMode = true;
  blizzardInterval = setInterval(() => {
    const x = rand(0, window.innerWidth);
    const y = window.scrollY + rand(0, window.innerHeight * 0.3);
    addStr(x, y);
  }, 40); // insane spawn rate
}

function disableBlizzardMode() {
  blizzardMode = false;
  clearInterval(blizzardInterval);
}

/* ===============================
   ADD SNOWFLAKE
   =============================== */
const addStr = (x, y) => {
  const str = document.createElement("div");
  str.innerHTML = '&#10022;';
  str.className = 'snowflake';
  str.style.position = 'absolute';
  str.style.top = `${y + rand(-40,40)}px`;
  str.style.left = `${x}px`;
  str.style.color = selRand(colors);
  str.style.pointerEvents = 'none';
  str.style.willChange = 'transform, opacity';
  str.style.fontSize = blizzardMode ? selRand(['2rem','3rem','4rem']) : selRand(fsize);
  document.body.appendChild(str);

  const fs = 10 + 5 * parseFloat(getComputedStyle(str).fontSize);
  const viewportY = y - window.scrollY;
  const fallDist = (viewportY + fs > vh ? vh - viewportY : fs);

  // Wind drift
  const wind = blizzardMode ? rand(-80,80) : rand(-20,20);
  const lightWind = blizzardMode ? rand(-20,20) : rand(-5,5);

  str.animate(
    {
      translate: [
        `${lightWind}px ${fallDist * fallDirection * 0.3}px`,
        `${wind}px ${fallDist * fallDirection}px`
      ],
      opacity: [1,0]
    },
    {
      duration: delay,
      fill: 'forwards'
    }
  );

  setTimeout(() => str.remove(), delay);
};

/* ===============================
   MOUSE TRAIL
   =============================== */
addEventListener("mousemove", (e) => {
  const {pageX, pageY} = e;
  if (shouldDraw(pageX, pageY)) {
    addStr(pageX, pageY);
    x1 = pageX;
    y1 = pageY;
  }
});

/* ===============================
   BLIZZARD TOGGLE
   =============================== */
addEventListener("keydown", (e) => {
  if (e.key.toLowerCase() === "b") {
    blizzardMode ? disableBlizzardMode() : enableBlizzardMode();
  }
});

function createSantaPNG() {
  let santa = document.getElementById("png-santa");
  if (santa) return santa;

  santa = document.createElement("img");
  santa.id = "png-santa";
  santa.src = "https://cdn.shopify.com/s/files/1/0739/1169/7684/files/santa.png";
  santa.style.position = "absolute";
  santa.style.width = "220px";     // adjust size here
  santa.style.pointerEvents = "none";
  santa.style.zIndex = "999999";
  santa.style.display = "none";
  santa.style.filter = "drop-shadow(0px 0px 8px rgba(255,255,255,0.9))";

  document.body.appendChild(santa);
  return santa;
}

function santaFlyBy() {
  const santa = createSantaPNG();

  // Random height anywhere in the visible viewport
  const startY = window.scrollY + rand(50, vh - 150);

  santa.style.top = startY + "px";
  santa.style.left = "-300px"; // start off-screen
  santa.style.display = "block";

  santa.animate(
    {
      transform: [
        "translateX(0px)",
        "translateX(" + (window.innerWidth + 800) + "px)"
      ]
    },
    {
      duration: 6000,    // speed of fly-by (lower = faster)
      easing: "ease-in-out",
      fill: "forwards"
    }
  );

  setTimeout(() => {
    santa.style.display = "none";
  }, 6000);
}

/* ===============================
   HOTKEY: S TO SUMMON SANTA
   =============================== */
addEventListener("keydown", (e) => {
  if (e.key.toLowerCase() === "s") {
    santaFlyBy();
  }
});